import { API } from 'aws-amplify';

const subscribeUser = async user => {
  const result = await API.post('agentbuzz', 'subscriptions', {
    body: createSubscriptionData(user),
  });
  return result.s_customerId;
};

const createSubscriptionData = data => {
  const subscriptionData = {
    token: data.id,
    email: data.email,
    name: data.name,
    phoneNumber: data.phoneNumber,
    description: `Plan ${data.plan.name} Subscription`,
    address: {
      line1: data.card.address_line1,
      line2: data.card.address_line2 || null,
      city: data.card.address_city,
      state: data.card.address_state,
      zip: data.card.address_zip,
    },
    plan: {
      s_planId: `plan_${data.plan.id}`,
    },
    fee: data.plan.shipping * 100, // must be in cents
    feeDescription: 'One time signrider shipping charges.',
  };
  return subscriptionData;
};
export default subscribeUser;



// WEBPACK FOOTER //
// ./src/services/billing/subscribeUser.js